import React from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';

const ProductImage = (props) => {
  const backgroundColor =
    props.blok.background_color && props.blok.background_color.color !== '#f40000'
      ? props.blok.background_color.color
      : '#f7f7f7';

  if (!props.blok.image || !props.blok.image.filename) {
    return <span>Product Image Required</span>;
  }

  return (
    <SbEditable content={props.blok}>
      <ProductContainer backgroundColor={backgroundColor}>
        <ProductPicture src={props.blok.image.filename} />
        <ProductTitle>{props.blok.title}</ProductTitle>
        <ProductDescription>{props.blok.description}</ProductDescription>
      </ProductContainer>
    </SbEditable>
  );
};

export default ProductImage;

const ProductContainer = styled.div`
  max-width: 345px;
  background-color: ${(props) => props.background_color || '#f7f7f7'};
  text-align: center;
`;

const ProductPicture = styled.img`
  margin: 0;
  max-width: 100%;
`;

const ProductTitle = styled.h3`
  font-family: 'Gotham Bold';
  color: #333333;
  font-size: 1.2rem;
  line-height: 1.2rem;
  margin: 0 0 2rem 0;
  padding: 0 3.5rem;
`;

const ProductDescription = styled.p`
  color: #7a7a7a;
  font-size: 0.8rem;
  line-height: 1.5rem;
  margin: 0 0 2rem 0;
  padding: 0 3.5rem;
`;
